exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LoginElements-Buttons-formGroup{margin-bottom:15px}.LoginElements-Buttons-flex{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.LoginElements-Buttons-link{display:inline-block;padding:3px 5px;text-decoration:none;font-size:1.125em;color:#fff}@media (min-width:1280px){.LoginElements-Buttons-link{padding:3px 20px}}", ""]);

// exports
exports.locals = {
	"formGroup": "LoginElements-Buttons-formGroup",
	"flex": "LoginElements-Buttons-flex",
	"link": "LoginElements-Buttons-link"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/LoginElements/Buttons.css
// module id = 1449
// module chunks = 0 9